import { IHiddenRanges } from 'src/interfaces/global';
import { EMediaQuery } from 'src/styles/theme/utils/enums';
import { addHiddenRangesStyles, addTransition, mq } from 'src/styles/theme/utils/functions';
import styled, { css } from 'styled-components';

export const StyledSubLinkItem = styled.li<{ isDisabled?: boolean } & IHiddenRanges>`
	position: relative;

	${addTransition()}
	${(p) => addHiddenRangesStyles(p)}

	${(p) => (p.isDisabled ? 'pointer-events: none; opacity: 0.3;' : '')}

	&:nth-child(1) {
		margin-right: 15px;
	}

	& > p {
		font-size: 1rem;
	}

	& + li {
		margin-left: 15px;
	}

	${mq(
		EMediaQuery.md,
		css`
			margin-top: 5px;

			width: 100%;

			display: flex;
			justify-content: center;
			align-items: center;

			&:nth-child(1) {
				margin-right: 0px;
			}

			& + li {
				margin-left: 0px;
				margin-top: 0;
			}

			padding: 8px 0;

			&::before {
				content: ' ';
				position: absolute;

				bottom: 0;

				width: 50%;
				height: 1px;

				background: linear-gradient(270deg, rgba(71, 71, 71, 0) 1.92%, #474747 49.48%, rgba(71, 71, 71, 0) 100%);
			}

			&:nth-last-child(2) {
				&::before {
					width: 80%;
				}
			}
		`
	)}
`;

export const StyledSubmenusUnderline = styled.span`
	position: absolute;

	display: flex;

	justify-content: flex-start;
	align-items: center;

	height: 1px;

	bottom: 8px;
	left: -2px;
	right: 0;

	${(p) => `background: linear-gradient(to right, ${p.theme.colors.gold}, ${p.theme.colors.gold}00);`}

	${mq(EMediaQuery.md, 'display: none;')}

	&::before {
		position: absolute;
		content: ' ';
		height: 2px;
		width: 2px;
		background-color: ${(p) => p.theme.colors.gold};

		transform: rotate(45deg);
	}
`;
